import React from 'react';
import { FaInstagram, FaTiktok, FaFacebookF, FaHeart, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Footer.css';
import logo from '../assets/logo.jpg';

function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="brand-logo" onClick={() => scrollToSection('home')}>
              <img src={logo} alt="Maya's Flavours Logo" className="footer-logo-img" />
              <div className="brand-info">
                <span className="brand-name">Maya's Flavours</span>
                <span className="brand-tagline">{t('footer.tagline')}</span>
              </div>
            </div>
            <p className="brand-description">
              Viral French Fruit Desserts • Trompe-l'œil Fruit Desserts • Latsia, Cyprus
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-title">{t('footer.menu')}</h4>
            <nav className="footer-nav">
              <button onClick={() => scrollToSection('home')}>{t('nav.home')}</button>
              <button onClick={() => scrollToSection('about')}>{t('nav.about')}</button>
              <button onClick={() => scrollToSection('gallery')}>{t('nav.gallery')}</button>
              <button onClick={() => scrollToSection('testimonials')}>{t('nav.testimonials')}</button>
              <button onClick={() => scrollToSection('contact')}>{t('nav.contact')}</button>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-title">{t('nav.contact')}</h4>
            <div className="contact-info">
              <a href="tel:+35796420156" className="contact-item">
                <FaPhone />
                <span>96 420156</span>
              </a>
              <a 
                href="https://www.google.com/maps/dir/?api=1&destination=Maya's+Flavours,+Lefkosias+11,+Latsia,+Cyprus" 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-item"
              >
                <FaMapMarkerAlt />
                <span>{t('contact.locationText')}</span>
              </a>
            </div>
          </div>

          {/* Social Links */}
          <div className="footer-social">
            <h4 className="footer-title">{t('contact.followUs')}</h4>
            <div className="social-icons">
              <a 
                href="https://www.instagram.com/mayas_flavours/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.tiktok.com/@mayasflavours" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <FaTiktok />
              </a>
              <a 
                href="https://www.facebook.com/MayasFlavours" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Maya's Flavours. {t('footer.rights')}.
            </p>
            <p className="made-with">
              {t('footer.madeWith')} <FaHeart className="heart-icon" /> {t('footer.inCyprus')}
            </p>
            <p className="developed-by">
              {t('footer.designedBy')}{' '}
              <a 
                href="https://pmpnoveltysolutions.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="developer-link"
              >
                PMP Novelty Business Solutions
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="footer-decoration footer-deco-1"></div>
      <div className="footer-decoration footer-deco-2"></div>
    </footer>
  );
}

export default Footer;
